import axios from 'axios';
import { errorHelper, messageHelper } from '../helper.js';
import {
    PROPOSAL_DETAIL_URL,
      MY_PROPOSALS_URL,

} from '../../../vars';

/**
 * @namespace NewProposal
 * @description создание заявки (Page: /new-proposal/:id)
 */
export default {
    state: {
        files: null,
        my_proposals: null,
        dataQuize: [],
        newProposalCurrentStep: 1,
        newProposalPrevStep: 1,
        steppersCheckStatus: {
            step1: true,
            step2: true,
            step3: true,
            step4: true,
            step5: true,
        },
        steppersNeedCheck: {
            step1: false,
            step2: false,
            step3: false,
            step4: false,
            step5: false,
        },
    },

    mutations: {
        NEW_PROPOSAL_UPDATE_STEP(state, data){
            state.newProposalCurrentStep = data;
            if(state.newProposalPrevStep == 7){

            }
            else if(state.newProposalCurrentStep == 7){
                state.steppersNeedCheck = {
                    step1: true,
                    step2: true,
                    step3: true,
                    step4: true,
                    step5: true,
                }
            }
            else{
                var t = 'step' + state.newProposalPrevStep
                this.commit('NEW_PROPOSAL_UPDATE_STEPPER_NEED_CHECK', {name: t, value: true});
            }
            state.newProposalPrevStep = data;
        },
        NEW_PROPOSAL_UPDATE_STEPPER_CHECK_STATUS(state, data) {
            state.steppersCheckStatus[data.name] = data.value;
        },
        NEW_PROPOSAL_UPDATE_STEPPER_NEED_CHECK(state, data) {
            state.steppersNeedCheck[data.name] = data.value;
        },

        UPDATE_QUIZE(state, data) {
            state.dataQuize = { ...state.dataQuize, ...data };
        },
        UPDATE_MY_PROPOSALS(state, data) {
            state.my_proposals = data;
        },
        UPDATE_FILES(state, data) {
            state.files = data.data;
        },
    },

    actions: {
        /**
         * Промежуточная запись new-proposal
         * @param {Object} ctx
         * @param {Object} data Объект данных для записи
         * @throws {Object} Ошибка запроса данных
         *
         * @memberof Main
         */
        async PROPOSAL_DETAIL_UPDATE(ctx, data) {
            try {
                const res = await axios.patch(PROPOSAL_DETAIL_URL, {
                id: data.id,
                previous_proposals: data.previous_proposals,
                name: data.name,
                problem_formulation: data.problem_formulation,
                keywords: data.keywords,
                background: data.background,
                team_publications: data.team_publications,
                expected_results: data.expected_results,
                scientific_subjects: data.scientific_subjects,
                team: data.team,

                files: data.files,

                stations: data.stations,

                method: data.method,
                experiment_strategy: data.experiment_strategy,
                applicant_equipment: data.applicant_equipment,
                experiment_duration: data.experiment_duration,
                additional_equipment: data.additional_equipment,

                is_toxic: data.is_toxic,
                is_biohazard: data.is_biohazard,
                is_different_dangerous: data.is_different_dangerous,
                other_dangers: data.other_dangers,

                can_work_at_night: data.can_work_at_night,
                local_contacts: data.local_contacts,
                experiment_calendar: data.experiment_calendar,

                sample_description: data.sample_description,
                sample_avarage_size: data.sample_avarage_size,
                sample_type_id: data.sample_type_id,
                sample_volume: data.sample_volume,
                sample_surface_area: data.sample_surface_area,
                sample_mass: data.sample_mass,
                sample_count: data.sample_count,
                agreement_type:data.proposal_type,
                agreement_text:data.proposal_agreement,
                }, {
                headers: {
                    Authorization: `Token ${localStorage.token}`,
                },
                });
                return res;
            } catch (e) {
                errorHelper(e);
                messageHelper('', 'error', 6000, e);
                throw e;
            }
        },

        /**
         * получение списка данных для new-proposal
         * @param {Object} ctx
         * @param {String|Number} data Идентификатор
         *
         * @memberof Main
         */
        async REQUEST_NEW_PROPOSAL_DATA(ctx, data) {
            try {
                await axios.get(`${MY_PROPOSALS_URL}?view_type=short`, {
                    headers: {
                        Authorization: `Token ${localStorage.token}`,
                    },
                })
                .then((res) => ctx.commit('UPDATE_MY_PROPOSALS', res))
                .catch((e) => {
                    errorHelper(e);
                    messageHelper('', 'error', 6000, e);
                });

                // files
                await axios.get(`${PROPOSAL_DETAIL_URL}?id=${data}&expand=[%22files%22,%22team%22]`, {
                headers: {
                    Authorization: `Token ${localStorage.token}`,
                },
                })
                .then((res) => ctx.commit('UPDATE_FILES', res))
                .catch((e) => {
                    errorHelper(e);
                    messageHelper('', 'error', 6000, e);
                });

            } catch (ex) {
                console.log('ex store---> ', ex);
                messageHelper('', 'error', 6000, ex);
            }
        },

    },

    getters: {
        GETTERS_FILES(state) {
            return state.files;
        },
        GETTERS_MY_PROPOSALS(state) {
            return state.my_proposals;
        },
        GETTERS_DATA_QUIZE(state) {
            return state.dataQuize;
        },
        GETTERS_NEW_PROPOSAL_CURRENT_STEP(state) {
            return state.newProposalCurrentStep;
        },
        GETTERS_NEW_PROPOSAL_PREV_STEP(state) {
            return state.newProposalPrevStep;
        },
        GETTERS_NEW_PROPOSAL_STEPPER_CHECK_STATUS(state) {
            return state.steppersCheckStatus;
        },
        GETTERS_NEW_PROPOSAL_STEPPER_NEED_CHECK(state) {
            return state.steppersNeedCheck;
        },
    },
};
